"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var hub_1 = require("@sentry/hub");
var logger_1 = require("./logger");
/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instanciate.
 * @param options Options to pass to the client.
 * @returns The installed and bound client instance.
 */
function initAndBind(clientClass, options, defaultIntegrations) {
  if (defaultIntegrations === void 0) {
    defaultIntegrations = [];
  }
  if (options.debug) {
    logger_1.logger.enable();
  }
  if (hub_1.getCurrentHub().getClient()) {
    return;
  }
  var client = new clientClass(options);
  client.install();
  // This should happen here if any integration uses {@link Hub.addEventProcessor}
  // there needs to be a client on the hub already.
  hub_1.getCurrentHub().bindClient(client);
  var integrations = options.defaultIntegrations === false ? [] : __spread(defaultIntegrations);
  if (Array.isArray(options.integrations)) {
    var providedIntegrationsNames_1 = options.integrations.map(function (i) {
      return i.name;
    });
    integrations = __spread(integrations.filter(function (integration) {
      return providedIntegrationsNames_1.indexOf(integration.name) === -1;
    }), options.integrations);
  } else if (typeof options.integrations === 'function') {
    integrations = options.integrations(integrations);
  }
  // Just in case someone will return non-array from a `itegrations` callback
  if (Array.isArray(integrations)) {
    integrations.forEach(function (integration) {
      integration.install(options);
      logger_1.logger.log("Integration installed: " + integration.name);
    });
  }
}
exports.initAndBind = initAndBind;